/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_DeveloperInputs */

const id_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembang`)
};

const ms_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangun`)
};

const da_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udvikler`)
};

const de_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler`)
};

const en_us2_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const es_es2_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const es_mx2_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const fil_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const fr_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur`)
};

const it_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatore`)
};

const hu_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlesztő`)
};

const nl_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontwikkelaar`)
};

const no_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvikler`)
};

const pl_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deweloper`)
};

const pt_br2_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const pt_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

const ro_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezvoltator`)
};

const fi_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehittäjä`)
};

const sv_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvecklare`)
};

const vi_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà phát triển`)
};

const tr_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirici`)
};

const cs_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vývojář`)
};

const bg_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const ru_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const uk_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розробник`)
};

const ar_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المطور`)
};

const hi_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर`)
};

const th_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้พัฒนา`)
};

const ja_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発元`)
};

const zh_cn2_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const zh_hant1_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const ko_components_comparison_developer = /** @type {(inputs: Components_Comparison_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Components_Comparison_DeveloperInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_developer = /** @type {((inputs?: Components_Comparison_DeveloperInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_DeveloperInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_developer(inputs)
	if (locale === "ms") return ms_components_comparison_developer(inputs)
	if (locale === "da") return da_components_comparison_developer(inputs)
	if (locale === "de") return de_components_comparison_developer(inputs)
	if (locale === "en-US") return en_us2_components_comparison_developer(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_developer(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_developer(inputs)
	if (locale === "fil") return fil_components_comparison_developer(inputs)
	if (locale === "fr") return fr_components_comparison_developer(inputs)
	if (locale === "it") return it_components_comparison_developer(inputs)
	if (locale === "hu") return hu_components_comparison_developer(inputs)
	if (locale === "nl") return nl_components_comparison_developer(inputs)
	if (locale === "no") return no_components_comparison_developer(inputs)
	if (locale === "pl") return pl_components_comparison_developer(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_developer(inputs)
	if (locale === "pt") return pt_components_comparison_developer(inputs)
	if (locale === "ro") return ro_components_comparison_developer(inputs)
	if (locale === "fi") return fi_components_comparison_developer(inputs)
	if (locale === "sv") return sv_components_comparison_developer(inputs)
	if (locale === "vi") return vi_components_comparison_developer(inputs)
	if (locale === "tr") return tr_components_comparison_developer(inputs)
	if (locale === "cs") return cs_components_comparison_developer(inputs)
	if (locale === "bg") return bg_components_comparison_developer(inputs)
	if (locale === "ru") return ru_components_comparison_developer(inputs)
	if (locale === "uk") return uk_components_comparison_developer(inputs)
	if (locale === "ar") return ar_components_comparison_developer(inputs)
	if (locale === "hi") return hi_components_comparison_developer(inputs)
	if (locale === "th") return th_components_comparison_developer(inputs)
	if (locale === "ja") return ja_components_comparison_developer(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_developer(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_developer(inputs)
	return ko_components_comparison_developer(inputs)
});
export { components_comparison_developer as "components.comparison.developer" }